
























































































































































































































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import SwEmailInput from './sw-email-input.vue';
import SwPwInput from './sw-pw-input.vue';
import { LoginModel } from '../interfaces/sw-login-interfaces';
import SwTfaDialog from './sw-tfa-dialog.vue';
import { messageService } from '@sonicwall/unified-ui-framework/src/shared/message-service';
import { envCongif } from '@/shared/env.config';
import { SetTFAModePayload } from '../../../core.store';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { Mutation } from 'vuex-class';
import SwCaptchaDialog from './sw-captcha-dialog.vue';
import TfaSetup from '../../../shared/tfasetup.vue';
import { Environment } from '../../../../shared/env.config';
import UpdatePassword from '@/modules/msw-profile/components/update-password.vue';
import SwAccountLockedDialog from './sw-account-locked-dialog.vue';
import * as decode from 'jwt-decode';
import { confirmService } from '@libs-uuif/shared/confirm-service';

@Component({
  components: {
    SwEmailInput,
    SwPwInput,
    SwTfaDialog,
    SwCaptchaDialog,
    TfaSetup,
    UpdatePassword,
    SwAccountLockedDialog,
  },
})
export default class SwLoginLeftLoginPanel extends SwExtendedVue {
  @Prop({ required: true })
  value: LoginModel;
  @Prop({ default: false })
  flatEdge: boolean;
  emailValid: boolean = true;
  pwReady: boolean = false;
  passwordValid: boolean = true;
  isDomainUser: boolean;
  deviceCode: string = '';
  tfaMedium: string = '';
  email: string = '';
  environment: string = envCongif.env.toLowerCase()
  .includes('prod') ? '' : envCongif.env;
  showRememberMe: boolean = false;
  userCaptchaData: any = {};
  captchaResponse: string = '';
  isCaptchaNeeded: boolean = false;
  showPasswordCaptcha: boolean = false;
  captchaText: string = '';
  showTFADialog: boolean = false;
  declineTFA: boolean = false;
  showTFASetupDialog: boolean = false;
  isGuestBuyNow: boolean = false;
  envConfig: Environment = envCongif;
  showUpdatePasswordDialog: boolean = false;
  showAccLockedDialog: boolean = false;
  checkIfUserIsEmployee: boolean = false;
  @Mutation
  setTfaMode: VuexMappedMutation<SetTFAModePayload>;
  @Watch('value.email')
  onEmailEmpty(val:any) {
    if (val === '') {
      this.value.password = '';
    }
  }
  checkEmail() {
    if (this.value.email.length > 0) {
      this.$store.commit('startLoading');
      this.$store.dispatch('getAppVersion')
        .then((resp: any) => {
          if (resp.operationStatus === 'OK' && resp.content.enableIDP) {
            // this.spinner = true;
            const payload = {
              emailAddress: this.value.email,
              source: 'MSW',
            };
            this.$store.dispatch('getIDPUrl', payload)
              .then((result: any) => {
                let spinnerFlag = true;
                if (result?.content?.isSPRedirect && result?.content?.isSPRedirect === 'YES') {
                  confirmService.confirm({
                    status: 'major',
                    message: String(this.$t('sp.spRedirectMsg2')),
                    buttons: [
                      {
                        key: 'cancel',
                        name: String(this.$t('accessMgmt.cancel')),
                      },
                      {
                        key: 'ok',
                        name: String(this.$t('accessMgmt.confirm')),
                        isDefault: true,
                      },
                    ],
                  })
                  .then((isConfirmed: any) => {
                    if (isConfirmed === 'ok') {
                      window.top.location.href = `${envCongif.sp_url}`;
                    }
                  });
                }
                if (result.content.hasOwnProperty('extAuth') && result.content['extAuth'] === 'YES') {
                  spinnerFlag = false;
                }
                if (result && result.content && result.content.IDPUrl && result.content.IDPUrl !== '') {
                  window.top.location.href = result.content.IDPUrl;
                  return;
                }
                if (spinnerFlag) {
                  this.$store.commit('stopLoading');
                }
              });
          }
        });
      if (
        this.value.email.split('@').length === 2 &&
        this.$store.getters.isFederatedEmail(this.value.email.split('@')[1])
      ) {
        this.$store.dispatch('isFederatedUser', this.value.email)
          .then((res: any) => {
            if (res?.content?.IDPUrl) {
              window.location.replace(res?.content?.IDPUrl);
            }
          })
          .catch((errorRes: any) => {
            console.error(errorRes.message);
          })
          .finally(() => {
            this.$store.commit('stopLoading');
            this.pwReady = true;
            this.makeFocus('passwordInput');
          });
      } else {
        this.pwReady = true;
        this.makeFocus('passwordInput');
      }
    } else {
      this.emailValid = false;
    }
  }
  validateLogin() {
    if (this.value.password.length > 0) {
      this.$store.commit('mutate', { property: 'clientId', with: 'MUIR1XHIS27' });
      let deviceCode: string = '';
      try {
        deviceCode = localStorage.getItem('deviceCode') || '';
      } catch (e) {
        console.error(e);
      }
      const obj = {
        deviceCode,
        userName: this.value.email,
        password: this.value.password,
        clientId: this.$store.getters.getClientId,
        captchaText: this.captchaText ? this.captchaText : '',
      };
      this.$store.commit('startLoading');
      this.$store.dispatch('getToken', obj)
        .then((res: any) => {
          if (res.operationStatus === 'OK') {
            this.checkIfUserIsEmployee = (res.content && res.content.userType && res.content.userType.toUpperCase() === 'FEDERATED') || false;
            if (res.content.showRememberMe) {
              this.showRememberMe = true;
            }
            if (res.content.deviceCode && res.content.deviceCode !== '') {
              localStorage.setItem('deviceCode',  res.content.deviceCode);
            }
            if (res.content.isLargeCustomer === 'YES') {
              localStorage.setItem('isLargeCustomer', 'YES');
            } else {
              localStorage.setItem('isLargeCustomer', 'NO');
            }
            if (res.content.isTFACaptchaNeeded && res.content.isTFACaptchaNeeded === 'YES') {
              this.isCaptchaNeeded = true;
            }
            if (res.content && res.content.TFAID) {
              localStorage.setItem('TFAID', res.content.TFAID.toString());
            }
            if (res.content.changePassword && res.content.changePassword === 'YES') {
              this.showUpdatePasswordDialog = true;
            }
            if (res.content && res.content.token && res.content.token !== '') {
              const decodedToken: any = decode(res.content.token);
              if (decodedToken.showPendo && decodedToken.showPendo !== '') {
                localStorage.setItem('showPendo', decodedToken.showPendo);
              }
            }
            this.$store.dispatch('preserveUserInfo', res)
            .then(() => {
              // const userInfo = JSON.parse(localStorage.getItem('currentUser') as any);
            });
            if (res.msgCode === 'MSWAPP:TFA') {
              this.tfaMedium = res.content.TFA.toUpperCase();
              this.setTfaMode({ mode: this.tfaMedium });
              this.email = res.content.emailAddress;
              this.showTFADialog = true;
            } else {
              if (res.content.forcetosetTFA &&
                res.content.forcetosetTFA.toUpperCase() === 'YES') {
                this.declineTFA = res.content?.declineTFA === 'YES' ? true : false;
                this.showTFASetupDialog = true;
              } else {
                this.$store.commit('mutate', { property: 'isGuestBuyNowUser', with: false });
                this.$store.commit('mutate', { property: 'loggedIn', with: true });
                if (this.$router.currentRoute.query!.redirectURL) {
                  const url = atob(this.$router.currentRoute.query.redirectURL as string);
                  this.$router.push(url.split('/workspace')[1]);
                } else {
                  if (this.isGuestBuyNow) {
                    this.$router.push('/m/feature/cart');
                  } else {
                    this.$router.push('/m/feature/dashboard');
                  }
                }
              }
            }
          } else if (res.messageCode === 'MSWAPP:ACCOUNTLOCKED') {
            this.$store.commit('stopLoading');
            const errorMessage = 'Your account has been locked. Please visit  MySonicwall.com to reset the password';
            messageService.messageManager.showMessage('login-message', errorMessage , 'failed');
            this.showAccLockedDialog = true;
          } else if (res.messageCode === 'MSWAPP:TEMPCUSTOMER') {
            this.$store.commit('stopLoading');
            const errorMessage = 'Please visit  MySonicwall.com to complete the signup Process';
            messageService.messageManager.showMessage('login-message', errorMessage , 'failed');
          } else if ((res.msgCode === 'SHOWCAPTCHA' ||
            res.msgCode === 'INVALIDCAPTCHA') &&
            res.content.hasOwnProperty('captchBaseString') &&
            res.content.captchBaseString &&
            res.content.hasOwnProperty('captchDetail') &&
            res.content.captchDetail) {
            this.userCaptchaData = {};
            this.userCaptchaData.captchDetail = res.content.captchDetail ? res.content.captchDetail : '';
            this.userCaptchaData.captchBaseString = res.content.captchBaseString ? res.content.captchBaseString : '';
            this.$store.commit('stopLoading');
            if (res.msgCode === 'INVALIDCAPTCHA') {
              messageService.messageManager.showMessage('login-message', res.msgDesc ? res.msgDesc : '' , 'failed');
            }
            this.showPasswordCaptcha = true;
          } else if (res.messageCode === 'MSWAPP:REQUESTREGISTRATIONCODE') {
            this.$store.commit('stopLoading');
            const errorMessage = 'Please visit  MySonicwall.com to complete the login.';
            messageService.messageManager.showMessage('login-message', errorMessage , 'failed');
          }  else {
            this.$store.commit('stopLoading');
            const errorMessage = res['msgDesc'] || 'The Username/Email address or Password entered, is not correct. Please check and try again.';
            messageService.messageManager.showMessage('login-message', errorMessage , 'failed');
          }
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        });
    } else {
      this.passwordValid = false;
    }
  }

  async created() {
    this.checkIfGuestBuynow();
    if (this.$router.currentRoute.query.redirectURL) {
      const redirectUrl = window.atob(this.$router.currentRoute.query.redirectURL.toString());
      if (redirectUrl.trim() === '/muir/spog/login?logout=true') {
        this.$router.replace('/muir/spog/login');
      }
    }
  }

  closeTFADialog() {
    this.showTFADialog = false;
    this.tfaMedium = '';
  }

  onCloseEvent(value: string = '') {
    if (value) {
      this.captchaText = value;
      this.validateLogin();
    }
    this.showPasswordCaptcha = false;
  }

  onCloseTFASetupDialog() {
    this.showTFASetupDialog = false;
  }

  mounted() {
    this.makeFocus('emailInput');
  }

  checkIfGuestBuynow() {
    if (this.$route.query.loginmode &&
      this.$route.query.loginmode.toString() === 'guestbuynow') {
      this.isGuestBuyNow = true;
    }
  }

  onClickGuestBuynow() {
    this.$router.push({ path:'/m/feature/cart' });
  }

  makeFocus(ref: string) {
    this.$nextTick(() => {
      if (ref === 'emailInput' && (this.$refs[ref] as SwEmailInput)) {
        // tslint:disable-next-line
        (this.$refs[ref] as SwEmailInput)?.$el?.getElementsByTagName('input')[0]?.focus(); 
      } else {
        if ((this.$refs[ref] as SwPwInput)) {
          // tslint:disable-next-line
          (this.$refs[ref] as SwPwInput)?.$el?.getElementsByTagName('input')[0]?.focus();
        }
      }
    });
  }
  onCloseUpdatePasswordModal(event:any) {
    console.warn(event);
    this.showUpdatePasswordDialog = false;
  }

  onCloseAccLockedModal(event:any) {
    console.warn(event);
    this.showAccLockedDialog = false;
  }
}
